const PENDING_INVITE_KEY = "lion_pro_pending_invite_token";
const PENDING_INVITE_EMAIL_KEY = "lion_pro_pending_invite_email";
const PENDING_INVITE_INTENT_KEY = "lion_pro_pending_invite_intent";

export type InviteIntent = "membership" | "certification";

export function persistInviteToken(token: string): void {
  if (typeof sessionStorage === "undefined") return;
  const trimmed = token.trim();
  if (!trimmed) return;
  sessionStorage.setItem(PENDING_INVITE_KEY, trimmed);
}

/** Store invite token and optional invited address (for matching on register/login). */
export function persistInviteContext(
  token: string,
  invitedEmail?: string | null,
  intent?: InviteIntent | null,
): void {
  persistInviteToken(token);
  if (typeof sessionStorage === "undefined") return;
  const email = invitedEmail?.trim().toLowerCase();
  if (email) {
    sessionStorage.setItem(PENDING_INVITE_EMAIL_KEY, email);
  } else {
    sessionStorage.removeItem(PENDING_INVITE_EMAIL_KEY);
  }
  if (intent === "certification" || intent === "membership") {
    sessionStorage.setItem(PENDING_INVITE_INTENT_KEY, intent);
  } else {
    sessionStorage.removeItem(PENDING_INVITE_INTENT_KEY);
  }
}

export function getInviteToken(): string | null {
  if (typeof sessionStorage === "undefined") return null;
  const raw = sessionStorage.getItem(PENDING_INVITE_KEY);
  return raw?.trim() ? raw.trim() : null;
}

export function getInviteEmail(): string | null {
  if (typeof sessionStorage === "undefined") return null;
  const raw = sessionStorage.getItem(PENDING_INVITE_EMAIL_KEY);
  return raw?.trim() ? raw.trim() : null;
}

export function getInviteIntent(): InviteIntent | null {
  if (typeof sessionStorage === "undefined") return null;
  const raw = sessionStorage.getItem(PENDING_INVITE_INTENT_KEY)?.trim();
  if (raw === "certification" || raw === "membership") return raw;
  return null;
}

/** True when a pending invite exists and the account email matches the invited address. */
export function inviteTokenMatchesEmail(accountEmail: string): boolean {
  const token = getInviteToken();
  const invited = getInviteEmail();
  if (!token || !invited) return false;
  return accountEmail.trim().toLowerCase() === invited;
}

export function clearInviteToken(): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(PENDING_INVITE_KEY);
  sessionStorage.removeItem(PENDING_INVITE_EMAIL_KEY);
  sessionStorage.removeItem(PENDING_INVITE_INTENT_KEY);
}
